var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
import { css } from 'styled-components';
import { theme } from '@shapeable/theme';
export var NOOP_QUERY = "query NoopQuery { noop }";
export var LANGUAGE_EN = {
  id: 'langugage-en',
  path: 'en',
  iso: 'en',
  locale: 'en_GB',
  name: 'English',
  label: 'English Version'
};
export var LANGUAGE_FR = {
  id: 'langugage-fr',
  path: 'fr',
  iso: 'fr',
  locale: 'fr_FR',
  name: 'Français',
  label: 'Version Français'
};
export var PLATFORM_DATETIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss';
export var PLATFORM_DATE_FORMAT = 'YYYY-MM-DD';
export var PLATFORM_MONTH_FORMAT = 'YYYY-MM';
export var WARM_GREY = '#ECEDE8';
export var RED = '#FF0000';
export var GREEN = '#56C02B';
export var OVERLAY_SHADOW = '0 1px 1px rgba(0, 0, 0, 0.3)';
export var COLOR_WARM_GREY = {
  value: WARM_GREY
};
export var COLOR_GRAY = {
  id: 'color-gray',
  slug: 'color-gray',
  name: 'Gray',
  value: '#666666'
};
export var COLOR_WHITE = {
  id: 'color-white',
  slug: 'color-white',
  name: 'White',
  value: '#FFFFFF',
  darkValue: '#333333',
  lightValue: '#CCCCCC',
  veryLightValue: '#EEEEEE',
  veryDarkValue: '#111111'
};
export var COLOR_BLACK = {
  id: 'color-black',
  slug: 'color-black',
  name: 'Black',
  value: '#000000'
};
export var DEFAULT_SITE = {
  id: "website",
  name: 'Website',
  languages: [LANGUAGE_EN]
};
export var PAGE_HOME = {
  id: 'home',
  path: '/',
  name: 'Home'
};
export var PAGE_KNOWLEDGE_HUB = {
  id: 'knowledge-hub',
  path: '/knowledge-hub',
  name: 'Knowledge Hub'
};
export var PAGE_EVENTS = {
  id: 'events',
  path: '/events',
  name: 'Events'
};
export var PAGE_NOT_FOUND = {
  name: 'Page Not Found',
  slug: '',
  intro: {
    text: "# Sorry we couldn\u2019t find what you were looking for."
  },
  content: {
    text: "Please use the site navigation to find what you're looking for, or [Return to the home page](/)."
  }
};
export var CSS_DOTS_END = css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), theme.H_DOT_BG_END('secondary', 2, 8));
export var CSS_DOTS = css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", ";\n"], ["\n  ", ";\n"])), theme.H_DOT_BG('secondary', 2, 8));
// For all of the above slice layouts, create synthetic entities for testing or directly using them 
export var SLICE_LAYOUT_BACKGROUND_IMAGE = {
  id: 'slice-layout-background-image',
  slug: 'slice-layout-background-image',
  component: 'SliceLayoutBackgroundImage'
};
export var SLICE_LAYOUT_BANNER_TABS = {
  id: 'slice-layout-banner-tabs',
  slug: 'slice-layout-banner-tabs',
  component: 'SliceLayoutBannerTabs'
};
export var SLICE_LAYOUT_BANNER_TOUT = {
  id: 'slice-layout-banner-tout',
  slug: 'slice-layout-banner-tout',
  component: 'SliceLayoutBannerTout'
};
export var SLICE_LAYOUT_BLURB_IMAGE = {
  id: 'slice-layout-blurb-image',
  slug: 'slice-layout-blurb-image',
  component: 'SliceLayoutBlurbImage'
};
export var SLICE_LAYOUT_BLURB_VIDEO = {
  id: 'slice-layout-blurb-video',
  slug: 'slice-layout-blurb-video',
  component: 'SliceLayoutBlurbVideo'
};
export var SLICE_LAYOUT_BLOCK_BUBBLE_LINKS = {
  id: 'slice-layout-block-bubble-links',
  slug: 'slice-layout-block-bubble-links',
  component: 'SliceLayoutBlockBubbleLinks'
};
export var SLICE_LAYOUT_BLOCK_BUBBLES = {
  id: 'slice-layout-block-bubbles',
  slug: 'slice-layout-block-bubbles',
  component: 'SliceLayoutBlockBubbles'
};
export var SLICE_LAYOUT_BLOCK_GRID = {
  id: 'slice-layout-block-grid',
  slug: 'slice-layout-block-grid',
  component: 'SliceLayoutBlockGrid'
};
export var SLICE_LAYOUT_BLOCK_THUMBNAIL_CARD_GRID = {
  id: 'slice-layout-block-thumbnail-card-grid',
  slug: 'slice-layout-block-thumbnail-card-grid',
  component: 'SliceLayoutBlockThumbnailCardGrid'
};
export var SLICE_LAYOUT_BLOCK_THUMBNAIL_GRID = {
  id: 'slice-layout-block-thumbnail-grid',
  slug: 'slice-layout-block-thumbnail-grid',
  component: 'SliceLayoutBlockThumbnailGrid'
};
export var SLICE_LAYOUT_BLOCK_TOUT_GRID = {
  id: 'slice-layout-block-tout-grid',
  slug: 'slice-layout-block-tout-grid',
  component: 'SliceLayoutBlockToutGrid'
};
export var SLICE_LAYOUT_COLLEAGUES_LIST = {
  id: 'slice-layout-colleagues-list',
  slug: 'slice-layout-colleagues-list',
  component: 'SliceLayoutColleaguesList'
};
export var SLICE_LAYOUT_COLOR_STRIP = {
  id: 'slice-layout-color-strip',
  slug: 'slice-layout-color-strip',
  component: 'SliceLayoutColorStrip'
};
export var SLICE_LAYOUT_CONNECTIONS = {
  id: 'slice-layout-connections',
  slug: 'slice-layout-connections',
  component: 'SliceLayoutConnections'
};
export var SLICE_LAYOUT_CONNECTIONS_PANEL = {
  id: 'slice-layout-connections-panel',
  slug: 'slice-layout-connections-panel',
  component: 'SliceLayoutConnectionsPanel'
};
export var SLICE_LAYOUT_CONNECTIONS_SIDEBAR = {
  id: 'slice-layout-connections-sidebar',
  slug: 'slice-layout-connections-sidebar',
  component: 'SliceLayoutConnectionsSidebar'
};
export var SLICE_LAYOUT_CONTACT_FORM = {
  id: 'slice-layout-contact-form',
  slug: 'slice-layout-contact-form',
  component: 'SliceLayoutContactForm'
};
export var SLICE_LAYOUT_CONTACT_INFO = {
  id: 'slice-layout-contact-info',
  slug: 'slice-layout-contact-info',
  component: 'SliceLayoutContactInfo'
};
export var SLICE_LAYOUT_CONTENT = {
  id: 'slice-layout-content',
  slug: 'slice-layout-content',
  component: 'SliceLayoutContent'
};
export var SLICE_LAYOUT_CONTENT_BLOCK_LINKS = {
  id: 'slice-layout-content-block-links',
  slug: 'slice-layout-content-block-links',
  component: 'SliceLayoutContentBlockLinks'
};
export var SLICE_LAYOUT_CONTENT_ENTITY_QUOTE = {
  id: 'slice-layout-content-entity-quote',
  slug: 'slice-layout-content-entity-quote',
  component: 'SliceLayoutContentEntityQuote'
};
export var SLICE_LAYOUT_CONTENT_IMAGE = {
  id: 'slice-layout-content-image',
  slug: 'slice-layout-content-image',
  component: 'SliceLayoutContentImage'
};
export var SLICE_LAYOUT_CONTENT_IMAGE_REVERSE = {
  id: 'slice-layout-content-image-reverse',
  slug: 'slice-layout-content-image-reverse',
  component: 'SliceLayoutContentImageReverse'
};
export var SLICE_LAYOUT_CONTENT_PANEL = {
  id: 'slice-layout-content-panel',
  slug: 'slice-layout-content-panel',
  component: 'SliceLayoutContentPanel'
};
export var SLICE_LAYOUT_CONVERSATION = {
  id: 'slice-layout-conversation',
  slug: 'slice-layout-conversation',
  component: 'SliceLayoutConversation'
};
export var SLICE_LAYOUT_CURRENT_EVENTS = {
  id: 'slice-layout-current-events',
  slug: 'slice-layout-current-events',
  component: 'SliceLayoutCurrentEvents'
};
export var SLICE_LAYOUT_DESCRIPTION = {
  id: 'slice-layout-description',
  slug: 'slice-layout-description',
  component: 'SliceLayoutDescription'
};
export var SLICE_LAYOUT_ENTITY_PAGE_BANNER = {
  id: 'slice-layout-intro',
  slug: 'slice-layout-intro',
  component: 'SliceLayoutEntityPageBanner'
};
export var SLICE_LAYOUT_ENTITY_ITEMS = {
  id: 'slice-layout-entity-items',
  slug: 'slice-layout-entity-items',
  component: 'SliceLayoutEntityItems'
};
export var SLICE_LAYOUT_ENTITY_TYPE_TABS = {
  id: 'slice-layout-entity-type-tabs',
  slug: 'slice-layout-entity-type-tabs',
  component: 'SliceLayoutEntityTypeTabs'
};
export var SLICE_LAYOUT_DIVIDER = {
  id: 'slice-layout-divider',
  slug: 'slice-layout-divider',
  component: 'SliceLayoutDivider'
};
export var SLICE_LAYOUT_FEATURE_TOUT = {
  id: 'slice-layout-feature-tout',
  slug: 'slice-layout-feature-tout',
  component: 'SliceLayoutFeatureTout'
};
export var SLICE_LAYOUT_FEATURED_ORGANISATION = {
  id: 'slice-layout-featured-organisation',
  slug: 'slice-layout-featured-organisation',
  component: 'SliceLayoutFeaturedOrganisation'
};
export var SLICE_LAYOUT_FEATURED_POSTS = {
  id: 'slice-layout-featured-posts',
  slug: 'slice-layout-featured-posts',
  component: 'SliceLayoutFeaturedPosts'
};
export var SLICE_LAYOUT_HAIRLINE = {
  id: 'slice-layout-hairline',
  slug: 'slice-layout-hairline',
  component: 'SliceLayoutHairline'
};
export var SLICE_LAYOUT_HEADER = {
  id: 'slice-layout-header',
  slug: 'slice-layout-header',
  component: 'SliceLayoutHeader'
};
export var SLICE_LAYOUT_HEADER_DIVIDER = {
  id: 'slice-layout-header-divider',
  slug: 'slice-layout-header-divider',
  component: 'SliceLayoutHeaderDivider'
};
export var SLICE_LAYOUT_IMAGE = {
  id: 'slice-layout-image',
  slug: 'slice-layout-image',
  component: 'SliceLayoutImage'
};
export var SLICE_LAYOUT_IMAGE_FILL = {
  id: 'slice-layout-image-fill',
  slug: 'slice-layout-image-fill',
  component: 'SliceLayoutImageFill'
};
export var SLICE_LAYOUT_INDICATOR_GROUPS_PANEL = {
  id: 'slice-layout-indicator-groups-panel',
  slug: 'slice-layout-indicator-groups-panel',
  component: 'SliceLayoutIndicatorGroupsPanel'
};
export var SLICE_LAYOUT_INDICATOR_GROUPS_SIDEBAR = {
  id: 'slice-layout-indicator-groups-sidebar',
  slug: 'slice-layout-indicator-groups-sidebar',
  component: 'SliceLayoutIndicatorGroupsSidebar'
};
export var SLICE_LAYOUT_INDICATORS_PANEL = {
  id: 'slice-layout-indicators-panel',
  slug: 'slice-layout-indicators-panel',
  component: 'SliceLayoutIndicatorsPanel'
};
export var SLICE_LAYOUT_INDICATORS_SIDEBAR = {
  id: 'slice-layout-indicators-sidebar',
  slug: 'slice-layout-indicators-sidebar',
  component: 'SliceLayoutIndicatorsSidebar'
};
export var SLICE_LAYOUT_INTRO = {
  id: 'slice-layout-intro',
  slug: 'slice-layout-intro',
  component: 'SliceLayoutIntro'
};
export var SLICE_LAYOUT_KEY_MESSAGE = {
  id: 'slice-layout-key-message',
  slug: 'slice-layout-key-message',
  component: 'SliceLayoutKeyMessage'
};
export var SLICE_LAYOUT_KEY_PILLARS = {
  id: 'slice-layout-key-pillars',
  slug: 'slice-layout-key-pillars',
  component: 'SliceLayoutKeyPillars'
};
export var SLICE_LAYOUT_KNOWLEDGE_HUB = {
  id: 'slice-layout-knowledge-hub',
  slug: 'slice-layout-knowledge-hub',
  component: 'SliceLayoutKnowledgeHub'
};
export var SLICE_LAYOUT_LATEST_INSIGHTS = {
  id: 'slice-layout-latest-insights',
  slug: 'slice-layout-latest-insights',
  component: 'SliceLayoutLatestInsights'
};
export var SLICE_LAYOUT_MARKET_MAP_GRID = {
  id: 'slice-layout-market-map-grid',
  slug: 'slice-layout-market-map-grid',
  component: 'SliceLayoutMarketMapGrid'
};
export var SLICE_LAYOUT_MARKET_MAP_PANEL = {
  id: 'slice-layout-market-map-panel',
  slug: 'slice-layout-market-map-panel',
  component: 'SliceLayoutMarketMapPanel'
};
export var SLICE_LAYOUT_MODERATORS = {
  id: 'slice-layout-moderators',
  slug: 'slice-layout-moderators',
  component: 'SliceLayoutModerators'
};
export var SLICE_LAYOUT_ONBOARDING_OBJECTIVES_GRID = {
  id: 'slice-layout-onboarding-objectives-grid',
  slug: 'slice-layout-onboarding-objectives-grid',
  component: 'SliceLayoutOnboardingObjectivesGrid'
};
export var SLICE_LAYOUT_ONBOARDING_PROFILE_TYPES_GRID = {
  id: 'slice-layout-onboarding-profile-types-grid',
  slug: 'slice-layout-onboarding-profile-types-grid',
  component: 'SliceLayoutOnboardingProfileTypesGrid'
};
export var SLICE_LAYOUT_ONBOARDING_TREND_EXPERTISE_GRID = {
  id: 'slice-layout-onboarding-trend-expertise-grid',
  slug: 'slice-layout-onboarding-trend-expertise-grid',
  component: 'SliceLayoutOnboardingTrendExpertiseGrid'
};
export var SLICE_LAYOUT_ORGANISATION_BANNER = {
  id: 'slice-layout-organisation-banner',
  slug: 'slice-layout-organisation-banner',
  component: 'SliceLayoutOrganisationBanner'
};
export var SLICE_LAYOUT_ORGANISATION_BIO_GRID = {
  id: 'slice-layout-organisation-bio-grid',
  slug: 'slice-layout-organisation-bio-grid',
  component: 'SliceLayoutOrganisationBioGrid'
};
export var SLICE_LAYOUT_ORGANISATIONS = {
  id: 'slice-layout-organisations',
  slug: 'slice-layout-organisations',
  component: 'SliceLayoutOrganisations'
};
export var SLICE_LAYOUT_PARTNERED_ORGANISATIONS_GRID = {
  id: 'slice-layout-partnered-organisations-grid',
  slug: 'slice-layout-partnered-organisations-grid',
  component: 'SliceLayoutPartneredOrganisationsGrid'
};
export var SLICE_LAYOUT_PAST_EVENTS = {
  id: 'slice-layout-past-events',
  slug: 'slice-layout-past-events',
  component: 'SliceLayoutPastEvents'
};
export var SLICE_LAYOUT_PEOPLE = {
  id: 'slice-layout-people',
  slug: 'slice-layout-people',
  component: 'SliceLayoutPeople'
};
export var SLICE_LAYOUT_PERSON_BANNER = {
  id: 'slice-layout-person-banner',
  slug: 'slice-layout-person-banner',
  component: 'SliceLayoutPersonBanner'
};
export var SLICE_LAYOUT_QUESTION = {
  id: 'slice-layout-question',
  slug: 'slice-layout-question',
  component: 'SliceLayoutQuestion'
};
export var SLICE_LAYOUT_SECTION = {
  id: 'slice-layout-section',
  slug: 'slice-layout-section',
  component: 'SliceLayoutSection'
};
export var SLICE_LAYOUT_SECTION_REVERSE = {
  id: 'slice-layout-section-reverse',
  slug: 'slice-layout-section-reverse',
  component: 'SliceLayoutSectionReverse'
};
export var SLICE_LAYOUT_SPACER_128 = {
  id: 'slice-layout-spacer-128',
  slug: 'slice-layout-spacer-128',
  component: 'SliceLayoutSpacer128'
};
export var SLICE_LAYOUT_SPACER_192 = {
  id: 'slice-layout-spacer-192',
  slug: 'slice-layout-spacer-192',
  component: 'SliceLayoutSpacer192'
};
export var SLICE_LAYOUT_SPACER_256 = {
  id: 'slice-layout-spacer-256',
  slug: 'slice-layout-spacer-256',
  component: 'SliceLayoutSpacer256'
};
export var SLICE_LAYOUT_SPACER_32 = {
  id: 'slice-layout-spacer-32',
  slug: 'slice-layout-spacer-32',
  component: 'SliceLayoutSpacer32'
};
export var SLICE_LAYOUT_SPACER_64 = {
  id: 'slice-layout-spacer-64',
  slug: 'slice-layout-spacer-64',
  component: 'SliceLayoutSpacer64'
};
export var SLICE_LAYOUT_SPACER_96 = {
  id: 'slice-layout-spacer-96',
  slug: 'slice-layout-spacer-96',
  component: 'SliceLayoutSpacer96'
};
export var SLICE_LAYOUT_STAKEHOLDER_GRID = {
  id: 'slice-layout-stakeholder-grid',
  slug: 'slice-layout-stakeholder-grid',
  component: 'SliceLayoutStakeholderGrid'
};
export var SLICE_LAYOUT_THEME_INSIGHTS = {
  id: 'slice-layout-theme-insights',
  slug: 'slice-layout-theme-insights',
  component: 'SliceLayoutThemeInsights'
};
export var SLICE_LAYOUT_THUMBNAIL_STRIP = {
  id: 'slice-layout-thumbnail-strip',
  slug: 'slice-layout-thumbnail-strip',
  component: 'SliceLayoutThumbnailStrip'
};
export var SLICE_LAYOUT_UPCOMING_EVENTS = {
  id: 'slice-layout-upcoming-events',
  slug: 'slice-layout-upcoming-events',
  component: 'SliceLayoutUpcomingEvents'
};
export var SLICE_LAYOUT_VALUE_TOUT = {
  id: 'slice-layout-value-tout',
  slug: 'slice-layout-value-tout',
  component: 'SliceLayoutValueTout'
};
export var SLICE_LAYOUT_VIEW_INTRO = {
  id: 'slice-layout-view-intro',
  slug: 'slice-layout-view-intro',
  component: 'SliceLayoutViewIntro'
};
export var SLICE_LAYOUT_WORKSTREAMS = {
  id: 'slice-layout-workstreams',
  slug: 'slice-layout-workstreams',
  component: 'SliceLayoutWorkstreams'
};
var templateObject_1, templateObject_2;